/** An API detail can be a string, validation array or structured policy object. */
export function apiErrorText(error: unknown, fallback: string): string {
  const detail = (error as { response?: { data?: { detail?: unknown } } })?.response?.data?.detail;
  return typeof detail === "string" && detail.trim() && detail.length <= 500 ? detail : fallback;
}
